export function getServerUrl() {
  const baseURL = process.env.VUE_APP_API_BASE_URL;

  if (!baseURL) {
    throw new Error("Base URL not defined in environment variables");
  }
  return baseURL;
}
